import {
    INTRO_SCREENS
} from './intro';
import {
    GOALS_SCREENS,
    GOALS_SCREENS_V2
} from './goals';
import {
    HABITS_SCREENS,
    HABITS_SCREENS_V2,
    HABITS_SCREENS_V3,
    HABITS_SCREENS_V4
} from './habits';
import {
    ABOUT_YOU_SCREENS,
    ABOUT_YOU_SCREENS_V2
} from './aboutYou';
import {
    PLAN_SCREENS,
    PLAN_SCREENS_V2,
    PLAN_SCREENS_V3
} from './plan';
import {
    CHECKOUT_SCREENS,
    CHECKOUT_SCREENS_V2,
    CHECKOUT_SCREENS_V3,
    CHECKOUT_SCREENS_V4
} from './checkout';
import {
    CHALLENGE_SCREENS
} from './challenge';

export default {
    INTRO_SCREENS,
    GOALS_SCREENS,
    GOALS_SCREENS_V2,
    HABITS_SCREENS,
    HABITS_SCREENS_V2,
    HABITS_SCREENS_V3,
    HABITS_SCREENS_V4,
    ABOUT_YOU_SCREENS,
    ABOUT_YOU_SCREENS_V2,
    PLAN_SCREENS,
    PLAN_SCREENS_V2,
    PLAN_SCREENS_V3,
    CHECKOUT_SCREENS,
    CHECKOUT_SCREENS_V2,
    CHECKOUT_SCREENS_V3,
    CHECKOUT_SCREENS_V4,
    CHALLENGE_SCREENS
};
